import { AutoComplete, Input, Spin, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";
import styles from "./Search.module.scss";
import FiltersSelectedTags from "../FilterSelectedTags/FilterSelectedTags";
import { SearchOutlined } from "@ant-design/icons";
const AutoCompleteFilters = ({
  placeholder,
  functionSearch,
  valueField,
  localStorageKey,
  filters,
  setFilters,
  entity,
  style,
  tagColor = "",
  getFirstItemOnEnter = false,
}) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState({ data: [], isLoading: false });
  const [enterPressed, setEnterPressed] = useState(false);
  const debouncedValue = useDebounce(query);
  useEffect(() => {
    let searchController;
    if (debouncedValue) {
      if (searchController) {
        searchController.abort();
      }

      const initOption = { value: debouncedValue, name: debouncedValue };

      setOptions({
        data: [initOption],
        isLoading: true,
      });

      if (debouncedValue.length > 2) {
        searchController = functionSearch(debouncedValue, (res) => {
          const options_list = res.map((item) => {
            return {
              ...item,
              value: !!valueField
                ? (item[valueField] || item.name || item.value)
                : item.name
                ? item.name
                : item.value,
              label: item.name ? item.name : item.value,
            };
          });
          setOptions({
            data: [
              ...(getFirstItemOnEnter ? [] : [initOption]),
              ...options_list,
            ],
            isLoading: false,
          });
        });
      } else {
        setOptions({
          data: [initOption],
          isLoading: false,
        });
      }
    } else {
      setOptions((prev) => ({ ...prev, data: [] }));
    }

    return () => {
      if (searchController) {
        searchController.abort();
      }
    };
  }, [debouncedValue]);

  useEffect(() => {
    if (enterPressed) {
      if (!getFirstItemOnEnter) {
        handleInputConfirm("", {
          value: query,
          name: query,
        });
      } else if (!!options.data.length && !options.isLoading) {
        handleInputConfirm("", options.data[0]);
      }
      setEnterPressed(false);
    }
  }, [enterPressed, options, getFirstItemOnEnter]);

  const handleInputSearch = (value) => {
    setQuery(value);
  };
  const handleInputConfirm = (_, option) => {
    if (typeof localStorageKey === "string") {
      const map = JSON.parse(localStorage.getItem(localStorageKey)) || {};
      if (!map[option.value]) {
        localStorage.setItem(
          localStorageKey,
          JSON.stringify({
            ...map,
            [option.value]: option.label,
          })
        );
      }
    }

    setFilters({
      ...filters,
      [`${entity}`]: filters[`${entity}`]
        ? Array.from(new Set([...filters[`${entity}`], `${option.value}`]))
        : [`${option.value}`],
    });
    setQuery("");
  };

  return (
    <div className={styles["search-container"]}>
      <AutoComplete
        value={query}
        options={options.data}
        placeholder={placeholder}
        onChange={handleInputSearch}
        onSelect={handleInputConfirm}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setEnterPressed(true);
          }
        }}
        style={style ? style : { width: "100%" }}
        dropdownRender={(menu) =>
          options.isLoading ? (
            <div style={{ padding: 8 }}>
              <Spin size="small" />
            </div>
          ) : (
            menu
          )
        }
        disabled={enterPressed}
      >
        <Input suffix={<SearchOutlined />} />
      </AutoComplete>
      <FiltersSelectedTags
        filters={{ [entity]: filters[entity] }}
        setFilters={setFilters}
      />
    </div>
  );
};

export default AutoCompleteFilters;
